// ABOUTME: Interview times as the talent reads them, always in the card's own time zone rather than the device's, and
// ABOUTME: the propose form's local input turned back into the UTC instant pro-core expects.
import { zonedTimeToUtc } from 'date-fns-tz';
import { DateFormat, formatDateWithTimezone } from 'utils/date';
import { InterviewTime } from './types';

export const formatInstant = (iso: string, timeZone: string): string =>
  `${formatDateWithTimezone(
    iso,
    DateFormat.WEEKDAY_WITH_MONTH,
    timeZone
  )}, ${formatDateWithTimezone(iso, DateFormat.TIME, timeZone)}`;

export const formatClock = (iso: string, timeZone: string): string =>
  formatDateWithTimezone(iso, DateFormat.TIME, timeZone);

/** "Monday, 1 June, 10:00–10:30" in the card's zone. */
export const formatTimeRange = (
  time: InterviewTime,
  timeZone: string
): string =>
  `${formatInstant(time.startsAt, timeZone)}–${formatClock(
    time.endsAt,
    timeZone
  )}`;

/** A `datetime-local` value ("2026-06-01T10:00"), read as a wall-clock time in `timeZone`, as an ISO instant. */
export const localInputToIso = (value: string, timeZone: string): string =>
  zonedTimeToUtc(value, timeZone).toISOString();

/** mm:ss, and h:mm:ss once an interview runs past the hour. */
export const formatElapsed = (ms: number): string => {
  const total = Math.max(0, Math.floor(ms / 1000));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  const pad = (value: number) => String(value).padStart(2, '0');
  return hours > 0
    ? `${hours}:${pad(minutes)}:${pad(seconds)}`
    : `${pad(minutes)}:${pad(seconds)}`;
};

/** "Example Logistics" reads EL, "Du" reads D: at most two letters, from the first two words. */
export const initialsOf = (name: string): string => {
  const letters = name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(word => Array.from(word)[0] ?? '')
    .join('')
    .toUpperCase();
  return letters || '?';
};
